import { createTheme } from '@mui/material/styles';
import palette from './palette';
import components from './components';

// define custom colors: https://material-ui.com/customization/palette/
declare module '@mui/material/styles/createPalette' {
  interface Palette {
    ink: Palette['primary'];
    sky: Palette['primary'];
    ghost: Palette['primary'];
  }
  interface PaletteOptions {
    ink: PaletteOptions['primary'];
    sky: PaletteOptions['primary'];
    ghost: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    flat: true;
    uncontained: true;
    floated: true;
    link: true;
  }

  interface IconButtonPropsVariantOverrides {
    floated: true;
  }

  export interface ButtonPropsColorOverrides {
    ink: true;
    sky: true;
    ghost: true;
  }

  export interface IconButtonPropsColorOverrides {
    ink: true;
    sky: true;
    ghost: true;
  }

  export interface InputBasePropsColorOverrides {
    ink: true;
    sky: true;
    ghost: true;
  }
}

declare module '@mui/material/InputBase' {
  interface InputBasePropsSizeOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
    full: true;
  }
}

export type PaletteKey =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'warning'
  | 'info'
  | 'success';

export const theme = createTheme({
  palette,
  // https://www.figma.com/file/9Vt2NHcvROzDq03Np1gzmO/Thrive-Design-System?node-id=2366-408&t=sT8n1POkAI3sghEO-0
  typography: {
    fontFamily: '"Mulish", sans-serif',
    fontSize: 16,
    allVariants: {
      color: '#333333',
      lineHeight: 1.5,
    },
    h1: {
      fontSize: 32,
      fontWeight: 700,
    },
    h2: {
      fontSize: 29,
      fontWeight: 700,
    },
    h3: {
      fontSize: 26,
      fontWeight: 700,
    },
    h4: {
      fontSize: 23,
      fontWeight: 700,
    },
    h5: {
      fontSize: 20,
      fontWeight: 700,
    },
    subtitle1: {
      fontSize: 18,
    },
    subtitle2: {
      fontSize: 18,
    },
    body1: {
      fontSize: 16,
    },
    body2: {
      fontSize: 14,
    },
    button: {
      fontSize: 16,
      fontWeight: 700,
    },
    caption: {
      fontSize: 13,
    },
    overline: {
      fontSize: 11,
    },
  },
  // @ts-ignore: MUI forgot about text-transform: none
  components,
});
